import './view-nav-button-prev-next.css';
import { h } from 'preact';

export default function ViewNavButtonPrevNext({ id, onClick, isNextButton }) {
	function handleClick() {
		if (typeof onClick === 'function') {
			onClick(id);
		}
	}

	return (
		<button class={'view-nav-button-prev-next' + (isNextButton ? ' view-nav-button-next' : ' view-nav-button-prev')} onClick={handleClick}>
			<div class="view-nav-button-prev-next-arrow-container">
				<svg class="view-nav-button-prev-next-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 31">
					<path fill="currentColor" d="M4.4,31L20,15.5L4.4,0L0,4.3l11.2,11.2L0,26.7L4.4,31z" />
				</svg>
			</div>
		</button>
	);
}
